import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ChatLoader: LoadableType = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Chat" */ '../src/Chat.tsx')).Chat,
});
